import { Button } from '../../Atoms/Button/Button';
import "./NewsInformation.scss";
import ReactMarkdown from "react-markdown";

const NewsInformation = ({date, title, image, subtitle, content}) => {
  return (
		<>
			<div className="newsInformation-container hypertext-width mt-40">
				<h5 className="t5 c-yellow ">{date}</h5>
				<h2 className="t2 ">{title}</h2>
				<div className="newsInformation-features-container flex space-between wrap">
					<div className="newsInformation-feature-container flex center-content-items">
						<p className="body-14 bold">GPS</p>
					</div>
					<div className="newsInformation-feature-container flex center-content-items">
						<p className="body-14 bold">Tracking</p>
					</div>
					<div className="newsInformation-feature-container flex center-content-items">
						<p className="body-14 bold">Business</p>
					</div>
					<div className="newsInformation-feature-container flex center-content-items">
						<p className="body-14 bold">Security</p>
					</div>
				</div>
				<div className="center mt-40">
					<img src={image} alt="News" className="all-width" />
				</div>
				<div className="mt-40">
					{/* {subtitle && <p className="body-18 bold c-black">{subtitle}</p>}
        {paragraph_1 && <p className="body-18">{paragraph_1}</p>}
        {paragraph_2 && <p className="body-18">{paragraph_2}</p>}
        {paragraph_3 && <p className="body-18">{paragraph_3}</p>} */}
					<ReactMarkdown>{content}</ReactMarkdown>
				</div>
			</div>
			<div className="max-width mt-40 mb-40">
				<Button
					content="Ir a atrás"
					type="button light-blue outline"
					buttonRoute="/noticias"
				/>
			</div>
		</>
	);
}

export default NewsInformation
